// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1p27j","label":"Completed_label__3ndwW"};